export const config = {
  intro: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: [
      '#ffd500',
      '#ffc800',
      '#ffa200',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
  tapToPlay: {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 1,
    dropShadowDistance: 2,
    fill: [
      '#d15ad3',
      '#ffa8ec',
    ],
    fontFamily: 'Druk Text Cy',
    fontWeight: 700,
    strokeThickness: 2,
  },
  symbolValue: {
    fill: [
      '#e5c7f5',
      '#e59fd6',
    ],
    fontFamily: 'Druk Text Cy',
    fontWeight: 300,
    strokeThickness: 1,
  },
}
